// extracted by mini-css-extract-plugin
export default {"lazyLoadImage":"_1AtK3","loaded":"_3uNIS"};